import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  CONSTANTS,
  REPORT_TYPES,
  SOCIAL_SOURCES_OPTIONS,
  VERTICALS,
  WORD_CLOUD_TYPE,
  HOTSTAR_ID,
} from "../../../constants/app-constant";
import { CustomBSDropdown } from "../../Shared";

const { V_PRINT, V_ONLINE, V_SOCIAL, V_FORUM, V_BLOG } = VERTICALS;

const {
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTrend,
  CityWiseMAVTrend,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  JournalistNOATrend,
  JournalistAnalysisPrint,
  EditionWiseNOATrend,
  JournalistCCMTrend,
  JournalistMAVTrend,
  JournalistWCTrend,
  JournalistTonalityCCMRanking,
  JournalistTonalityMAVRanking,
  JournalistTonalityNOARanking,
  JournalistTonalityWCRanking,
  KeywordCloudNOA,
  PublicationNOATrend,
  PublicationCCMTrend,
  TopPublicationWordCount,
  TopPublicationTrendWordCount,
  PublicationTonalityCCMRanking,
  PublicationTonalityMAVRanking,
  PublicationTonalityNOARanking,
  PublicationTonalityWCRanking,
  SOV_WC_TREND,
  PublicationMAVTrend,
  TonalityCCMTrend,
  TonalityMAVTrend,
  TonalityNAOTrend,
  StateWiseTrend,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
  CitySpecificReport,
  INFLUENCERS,
  TWITTER,
  TypeOfPost,
  AuthorFollowing,
  AuthorTweetCount,
  AuthorListed,
  AuthorLike,
  ShareRetweet,
  ReplyComment,
  Attachment,
  Like,
  MemberType,
  TopPosters,
  citywisenew,
  AuthorCreated,
  TopLanguages
} = REPORT_TYPES;

export default function WidgetInlineFilters({
  widget,
  selectedInlinePublication,
  setSelectedInlinePublication,
  selectedInlineJournalist,
  setSelectedInlineJournalist,
  selectedEdition,
  setSelectedEdition,
  selectedState,
  setSelectedState,
  editionList,
  stateList,
  selectedInlineWCType,
  setSelectedInlineWCType,
  setSelectedInlineSentiment,
  selectedInlineSentiment,
  selectedInlinePlatform,
  setSelectedInlinePlatform,
  selectedInlineEntity,
  setSelectedInlineEntity,
  reportCategory,
  entityList,
  selectedInlineWCEntity,
  setSelectedInlineWCEntity,
  setSelectedInlineInfluencerEntity,
  selectedInlineInfluencerEntity,
  setSelectedInlineAuthorFollowingEntity,
  selectedInlineAuthorFollowingEntity,
  setSelectedInlineAuthorTweetCountEntity,
  selectedInlineAuthorTweetCountEntity,
  setSelectedInlineAuthorListedEntity,
  selectedInlineAuthorListedEntity,
  setSelectedInlineAuthorLikeEntity,
  selectedInlineAuthorLikeEntity,

}) {
  const {
    inlineFilterApiData: {
      TopMediaDataPrint,
      TopJournalistDataOnline,
      TopJournalistDataPrint,
      TopPublicationClientPrint,
      TopPublicationClientOnline,
    },
  } = useSelector((state) => state.widgetReducer);
  const { type, report_type } = widget || {};
  const entity = useSelector((state) => state.filterReducer.socialEntityFilter);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const id = selectedClient && selectedClient.id;


  const shouldShowJournalistFilter = () => {
    const allowedAnalysisTypes = [
      JournalistNOATrend,
      JournalistCCMTrend,
      JournalistMAVTrend,
      JournalistWCTrend,
      JournalistTonalityNOARanking,
      JournalistTonalityMAVRanking,
      JournalistTonalityCCMRanking,
      JournalistTonalityWCRanking,
    ];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowOTTlistFilter = () => {
    const allowedAnalysisTypes = [JournalistAnalysisPrint, EditionWiseNOATrend];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowPublicationFilter = () => {
    const allowedAnalysisTypes = [
      PublicationNOATrend,
      PublicationCCMTrend,
      PublicationMAVTrend,
      PublicationTonalityNOARanking,
      TopPublicationTrendWordCount,
      TopPublicationWordCount,
      PublicationTonalityWCRanking,
      PublicationTonalityMAVRanking,
      PublicationTonalityCCMRanking,
      SOV_WC_TREND,
    ];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowCInfluencerEntityFilter = () => {
    return (
      (report_type == INFLUENCERS || report_type === AuthorCreated || report_type === TopLanguages ) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowCAuthorFollowingEntityFilter = () => {
    return (
      (report_type == AuthorFollowing) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowCAuthorTweetCountEntityFilter = () => {
    return (
      (report_type == AuthorTweetCount) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowCAuthorListedEntityFilter = () => {
    return (
      (report_type == AuthorListed) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowCAuthorLikeEntityFilter = () => {
    return (
      (report_type == AuthorLike) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowCityFilter = () => {
    const allowedAnalysisTypes = [
      CityWiseNOATrend,
      CityWiseTonality,
      CityWiseCCMTrend,
      CityWiseMAVTrend,
      CityWiseCCMTonality,
      CityWiseMAVTonality,
    ];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowStateFilter = () => {
    const allowedAnalysisTypes = [
      StateWiseTonality,
      StateWiseTrend
    ];
    if (allowedAnalysisTypes.indexOf(report_type) !== -1) {
      return true;
    }
  };

  const shouldShowWordCloudTypeFilter = () => {
    return (
      (report_type == KeywordCloudNOA) &&
      (type == V_SOCIAL || type == V_BLOG || type == V_FORUM)
    );
  };

  const shouldShowTonalityFilter = () => {
    return (
      report_type == TonalityNAOTrend ||
      report_type == StateWiseTrend ||
      report_type == TonalityCCMTrend ||
      report_type == TonalityMAVTrend
    );
  };

  const shouldShowChannelTypeFilter = () => {
    return (
      report_type == PLATFORM_TONALITY ||
      report_type == PLATFORM_TREND ||
      report_type == CitySpecificReport ||
      report_type == TypeOfPost ||
      report_type == ShareRetweet ||
      report_type == ReplyComment ||
      report_type == Attachment ||
      report_type == Like ||
      report_type == MemberType ||
      report_type == TopPosters ||
      report_type == citywisenew
    );
  };

  const listOfPlatforms =
    report_type == PLATFORM_TONALITY
      ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInFilters)
        : (report_type == TypeOfPost 
          ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInTypePost)
          : (report_type == ShareRetweet 
            ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInShareRetweet)
            : (report_type == ReplyComment 
              ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInReplyComment)
              : (report_type == Attachment 
                ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInAttachment)
                : (report_type == Like 
                  ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInReplyComment)
                  : (report_type == MemberType
                    ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInMemberType)
                    : (report_type == TopPosters
                      ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInReplyComment)
                      : (report_type == citywisenew
                        ? SOCIAL_SOURCES_OPTIONS.filter((e) => e.showInGeo)
                        : SOCIAL_SOURCES_OPTIONS))))))));

  let publicationList =
    (type == V_PRINT
      ? TopPublicationClientPrint
      : TopPublicationClientOnline) || {};

  publicationList = publicationList.returnData;
  let journalistList =
    (type == V_PRINT ? TopJournalistDataPrint : TopJournalistDataOnline) || {};
  journalistList = journalistList.returnData;

  let ottList = (type == V_PRINT ? TopMediaDataPrint : {}) || {};
  ottList = ottList.returnData;

  const getOTTDefault = () => {
    const defaultSelectedItem =
      ottList && ottList.length
        ? ottList.filter((ele) => parseInt(ele.entity_id) == HOTSTAR_ID)
        : [];
    return defaultSelectedItem.length
      ? {
        value: defaultSelectedItem[0].entity_id,
        label: defaultSelectedItem[0].entity_name,
      }
      : "";
  };

  const formattedEntList =
    (shouldShowCInfluencerEntityFilter() || shouldShowCAuthorFollowingEntityFilter() || shouldShowCAuthorTweetCountEntityFilter() || shouldShowCAuthorListedEntityFilter() || shouldShowCAuthorLikeEntityFilter()) &&
    entity &&
    entity.values.map(({ id, entity_name }) => {
      return {
        value: id,
        label: entity_name,
      };
    });
  const formatEntity =
    shouldShowWordCloudTypeFilter() &&
    entity &&
    entity.values.map(({ id, entity_name }) => {
      return {
        value: id,
        label: entity_name,
      };
    });

  return (
    <div className="filterOptions">
      {(type == V_PRINT || type == V_ONLINE) && (
        <>

          {shouldShowPublicationFilter() && (
            <div className="searchPublication">
              <CustomBSDropdown
                config={{
                  name: type == V_ONLINE ? "Website" : "Publication",
                  options:
                    Array.isArray(publicationList) &&
                    publicationList.map(
                      ({ publication_id, publication_name }) => {
                        return {
                          value: publication_id,
                          label: publication_name,
                        };
                      }
                    ),
                }}
                selectedItem={selectedInlinePublication}
                onSelect={setSelectedInlinePublication}
              />
            </div>
          )}

          {shouldShowJournalistFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  name: "Journalist",
                  options:
                    Array.isArray(journalistList) &&
                    journalistList.map(({ source_id, source_name }) => {
                      return {
                        value: source_id,
                        label: source_name,
                      };
                    }),
                }}
                selectedItem={selectedInlineJournalist}
                onSelect={setSelectedInlineJournalist}
              />
            </div>
          )}

          {shouldShowOTTlistFilter() && (
            <div className="entityFilter">
              <CustomBSDropdown
                config={{
                  defaultOption: getOTTDefault(),
                  name: "",
                  options:
                    Array.isArray(ottList) &&
                    ottList.map(({ entity_id, entity_name }) => {
                      return {
                        value: entity_id,
                        label: entity_name,
                      };
                    }),
                }}
                selectedItem={selectedInlineJournalist}
                onSelect={setSelectedInlineJournalist}
                hideAllOption={true}
              />
            </div>
          )}

          {shouldShowCityFilter() && (
            <div className="cityFilter">
              <CustomBSDropdown
                config={{
                  name: "Edition",
                  options:
                    Array.isArray(editionList) &&
                    editionList.map((el) => {
                      return {
                        value: el.id,
                        label: el.edition_name,
                      };
                    }),
                }}
                selectedItem={selectedEdition}
                onSelect={setSelectedEdition}
              />
            </div>
          )}
          {shouldShowStateFilter() && (
            <div className="stateFilter">
              <CustomBSDropdown
                config={{
                  name: "State",
                  options:
                    Array.isArray(stateList) &&
                    stateList.map((el) => {
                      return {
                        value: el.id,
                        label: el.state,
                      };
                    }),
                }}
                selectedItem={selectedState}
                onSelect={setSelectedState}
              />
            </div>
          )}
        </>
      )}
      {shouldShowWordCloudTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Word cloud type",
              options: WORD_CLOUD_TYPE,
              defaultOption: WORD_CLOUD_TYPE[2],
            }}
            selectedItem={selectedInlineWCType}
            onSelect={setSelectedInlineWCType}
          />
        </div>
      )}
      {shouldShowWordCloudTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formatEntity,
              defaultOption: formatEntity[0],
            }}
            selectedItem={
              selectedInlineWCEntity ? selectedInlineWCEntity : formatEntity[0]
            }
            onSelect={setSelectedInlineWCEntity}
          />
        </div>
      )}

      {shouldShowTonalityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{ name: "Sentiment", options: CONSTANTS.TONALITY }}
            selectedItem={selectedInlineSentiment}
            onSelect={setSelectedInlineSentiment}
          />
        </div>
      )}

      {shouldShowChannelTypeFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{ name: "Platform", options: listOfPlatforms }}
            selectedItem={selectedInlinePlatform}
            onSelect={setSelectedInlinePlatform}
          />
        </div>
      )}
      {shouldShowCInfluencerEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineInfluencerEntity
                ? selectedInlineInfluencerEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineInfluencerEntity}
          />
        </div>
      )}
      {shouldShowCAuthorFollowingEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineAuthorFollowingEntity
                ? selectedInlineAuthorFollowingEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineAuthorFollowingEntity}
          />
        </div>
      )}
      {shouldShowCAuthorTweetCountEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineAuthorTweetCountEntity
                ? selectedInlineAuthorTweetCountEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineAuthorTweetCountEntity}
          />
        </div>
      )}
      {shouldShowCAuthorListedEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineAuthorListedEntity
                ? selectedInlineAuthorListedEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineAuthorListedEntity}
          />
        </div>
      )}
      {shouldShowCAuthorLikeEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineAuthorLikeEntity
                ? selectedInlineAuthorLikeEntity
                : formattedEntList[0]
            }
            onSelect={setSelectedInlineAuthorLikeEntity}
          />
        </div>
      )}
      {/* {shouldShowCInfluencerEntityFilter() && (
        <div className="searchPublication">
          <CustomBSDropdown
            config={{
              name: "Entity",
              options: formattedEntList,
              defaultOption: formattedEntList[0],
            }}
            selectedItem={
              selectedInlineEntity ? selectedInlineEntity : formattedEntList[0]
            }
            onSelect={setSelectedInlineEntity}
          />
        </div>
      )} */}
    </div>
  );
}
